import type { FastifyReply, FastifyRequest } from "fastify";
import type {
  PaginationSchemaType,
  WhatsAppSchemaType,
} from "./whatsapp.schema.js";
import {
  queueWhatsAppMessage,
  allWhatsAppMessages,
} from "./whatsapp.service.js";

export const getAllWhatsAppMessages = async (
  req: FastifyRequest,
  reply: FastifyReply,
) => {
  try {
    const { limit, page } = req.query as PaginationSchemaType;
    const messages = await allWhatsAppMessages(req.server, limit, page);
    return reply.status(200).send(messages);
  } catch (error: any) {
    req.log.error("Error fetching WhatsApp messages:", error);
    return reply.status(500).send({
      status: "error",
      message: "Failed to fetch WhatsApp messages",
    });
  }
};

export const sendWhatsApp = async (
  req: FastifyRequest,
  reply: FastifyReply,
) => {
  const { numbers, message } = req.body as WhatsAppSchemaType;

  if (!numbers || numbers.length === 0) {
    return reply.status(400).send({
      status: "error",
      message: "No numbers provided in the request body",
    });
  }

  if (!message || message.trim() === "") {
    return reply.status(400).send({
      status: "error",
      message: "No message content provided",
    });
  }

  const results = await Promise.all(
    numbers.map((number) => queueWhatsAppMessage(req.server, number, message)),
  );

  return reply.status(202).send({
    status: "success",
    message: "Messages queued successfully for background sending",
    queuedCount: results.length,
    data: results,
  });
};
